import { success, error } from '@/utils/alert'

/* eslint-disable */
const validators = {
  email: new RegExp(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  ),
  url: new RegExp(
    /^(https?|ftp|rmtp|mms):\/\/(([A-Z0-9][A-Z0-9_-]*)(\.[A-Z0-9][A-Z0-9_-]*)+)(:(\d+))?\/?/i
  ),
  text: new RegExp(/^[a-zA-Z]+$/),
  digits: new RegExp(/^[\d() \.\:\-\+#]+$/),
  isodate: new RegExp(
    /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/
  )
};
/* eslint-enable */

export default {
  getTags () {
    this.$http.get('/v1/professional/keywords/keywords')
      .then((response) => {
        this.innerTags = [...response.data]
      })
  },
  saveTags () {
    if (this.innerTags.length > 0) {
      this.$http.post('/v1/professional/keywords/keywords', this.innerTags)
        .then((data) => {
          this.innerTags = [...data.data]
          console.log(this.innerTags)
          success('Palavras chave salva(s) com sucesso.')
        })
    }
    if (this.innerTags.length <= 0) {
      error('Favor informar uma palavra chave.')
    }
  },
  focusNewTag () {
    if (this.readOnly || !this.$el.querySelector('.new-tag')) {
      return
    }
    this.$el.querySelector('.new-tag').focus()
  },

  handleInputFocus () {
    this.isInputActive = true
  },

  handleInputBlur (e) {
    this.isInputActive = false
    this.addNew(e)
  },

  addNew (e) {
    const keyShouldAddTag = e
      ? this.addTagOnKeys.indexOf(e.keyCode) !== -1
      : true

    const typeIsNotBlur = e && e.type !== 'blur'

    if (
      (!keyShouldAddTag && (typeIsNotBlur || !this.addTagOnBlur)) ||
      this.isLimit
    ) {
      return
    }

    if (
      this.newTag &&
      (this.allowDuplicates || this.innerTags.indexOf(this.newTag) === -1) &&
      this.validateIfNeeded(this.newTag)
    ) {
      this.innerTags.push(this.newTag)
      this.newTag = ''
      this.tagChange()
    }
  },

  validateIfNeeded (tagValue) {
    if (this.validate === '' || this.validate === undefined) {
      return true
    }

    if (typeof this.validate === 'function') {
      return this.validate(tagValue)
    }

    if (
      typeof this.validate === 'string' &&
      Object.keys(validators).indexOf(this.validate) > -1
    ) {
      return validators[this.validate].test(tagValue)
    }

    if (
      typeof this.validate === 'object' &&
      this.validate.test !== undefined
    ) {
      return this.validate.test(tagValue)
    }

    return true
  },

  remove (index) {
    this.innerTags.splice(index, 1)
    this.tagChange()
  },

  removeLastTag () {
    if (this.newTag) {
      return
    }
    this.innerTags.pop()
    this.tagChange()
  },

  tagChange () {
    this.$emit('update:tags', this.innerTags)
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/companies/components/tags/resources/methods.js